import { parseDate } from "@/utils";

export interface BFilterOperation {
    label: string;
    key: string;
    default?: boolean;
}

export interface BFieldSelection {
    value: number | string;
    text: string;
}

export interface BFilterableField {
    property: string;
    label: string;
    operations: BFilterOperation[];
    editorComponent: "text-editor" | "date-editor" | "decimal-editor" | "list-editor";
    editorOptions?: BFieldSelection[];
}

export interface BFilter {
    property: string | null;
    operation: string | null;
    value?: any;
}

export interface BFilterOptions {
    filters: BFilter[];
}

export const decimalOperations: BFilterOperation[] = [
    { label: "is", key: "eq" },
    { label: "is not", key: "ne" },
    { label: "is greater than", key: "gt" },
    { label: "is greater or equals to", key: "ge" },
    { label: "is less than", key: "lt" },
    { label: "is less or equals to", key: "le" },
];

export const textOperations: BFilterOperation[] = [
    { label: "is", key: "eq" },
    { label: "is not", key: "ne" },
    { label: "contains", key: "contains", default: true },
    { label: "starts with", key: "starts" },
    { label: "ends with", key: "ends" },
];

export const listOperations: BFilterOperation[] = [
    { label: "is", key: "eq" },
    { label: "is not", key: "ne" },
];

export const dateTimeOperations: BFilterOperation[] = [
    { label: "is", key: "eq" },
    { label: "is not", key: "ne" },
    { label: "is after", key: "gt" },
    { label: "is on or after", key: "ge" },
    { label: "is before", key: "lt" },
    { label: "is on or before", key: "le" },
];

function escapeFilterValue(value: any): string {
    if (typeof value == "string") {
        return `"${value.replace(/"/g, '\\"')}"`;
    }
    return value;
}

export function describeFilters(filters: BFilter[], fields: BFilterableField[]): string {
    const describeFilter = (filter: BFilter) => {
        var field = fields.find((it) => it.property == filter.property);
        if (field) {

            var op = field.operations.find((op) => op.key == filter.operation);
            var v = filter.value;

            if (field.editorOptions != null && field.editorOptions.length > 0) {
                v = field.editorOptions.find((opt) => opt.value == v)!.text;
            }

            return `${field.label} ${op!.label} "${isDateTimeString(v)?v.split('T')[0]:v}"`;
        }
        
    };
    return (filters || []).map(describeFilter).filter(f=> f != '' && f != undefined).join(" and ");
}

function isDateTimeString(input: string): boolean {
    const datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/; //ex: "2024-11-25T13:30:00.000Z"
    return datePattern.test(input);
  }
